import { i18n } from "../util/i18n";

export function t(key: string, args?: any[]) {
  return i18n.global.t(key, args || []);
}

export const locale = computed(() => i18n.global.locale.value);